// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateRegistrationDate = registrationDateRange => ({
    registrationDateRange,
    type: actions.UPDATE_REGISTRATIONS_REVIEW_REGISTRATION_DATE
});



// WEBPACK FOOTER //
// ./src/reports/registrations-review/action-creators/update-registration-date.js